<template>
  <div>
    <div class="full-container">
      <div class="main-container">
        <div class="notfound">
          <div>
            <img v-lazy="'//doc.yctop.com/eft/www/images/notcont.jpg'" alt />
          </div>
          <div class="notcont">
            <h1>404!</h1>
            <p>{{ $t("notfound.p") }}</p>
            <router-link id="page_div" to="/">
              {{ $t("notfound.back") }}({{ num }}
              {{ $t("notfound.m") }})</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="text/css" scoped="true">
@import "~@/assets/css/view/notfound.css";
</style>
<script type="babel">
export default {
    data:function(){
        return {
            num:2,
        }
    },
    mounted: function(){
        this.doUpdate()
    },
    methods:{
        doUpdate: function(){
            let timer = setInterval(()=>{
                if(this.num > 0){
                    this.num--;
                }else{
                    clearInterval(timer);
                    this.$router.push('/');
                }
          },1000)
        }
    }
};
</script>
